<template>
  <div>
    <h4>{{ $t("login") }}</h4>
    <p class="widget-auth-info mb-n5">
      {{ $t("useYourEmailToLogin") }}
    </p>
    <login-form :redirect-url="destination" />
    <p class="widget-auth-info">
      <router-link to="/password-reset">{{ $t("forgotPassword") }}</router-link>
    </p>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LoginForm from "@/components/LoginForm.vue";
import CompanyService from "@/services/CompanyService";

export default {
  name: "LoginHseqView",
  data() {
    return {
      destination: this.$route.query.nextUrl ? this.$route.query.nextUrl : "/kma",
      partnerRef: this.$route.params.partnerRef
    };
  },
  components: {
    LoginForm
  },
  mounted() {
    this.getPartnerCompany();
  },
  methods: {
    ...mapActions("layout", {
      $setPartner: "setPartner",
      $setIsLoadingPartner: "setIsLoadingPartner"
    }),
    getPartnerCompany() {
      if (this.partnerRef && !this.$partner) {
        this.$setIsLoadingPartner(true);
        CompanyService.getPartnerByPartnerRef(this.partnerRef)
          .then((company) => {
            this.$setPartner(company);
          })
          .finally(() => {
            this.$setIsLoadingPartner(false);
          });
      }
    }
  },
  computed: {
    ...mapGetters("layout", { $partner: "partner" })
  }
};
</script>

<style scoped lang="scss"></style>
